module.exports = __webpack_public_path__ + "product-raw-grass-12.jpg?e067599dc1355e6611229a3b55981b7c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product-raw-grass-12.jpg
// module id = 27
// module chunks = 0